export default {
  FETCH_AUTH_DATA_PROGRESS: 'auth/fetch_data_progress',
  FETCH_AUTH_DATA_SUCCESS: 'auth/fetch_data_success',
  FETCH_AUTH_DATA_FAILED: 'auth/fetch_data_failed',
};
